import axios, { AxiosError } from 'axios';
import { logOut } from 'redux/reducers/auth';
import { store } from 'redux/store';

let Request = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: { Accept: 'application/json' },
});

export const setupInterceptors = (rootStore: typeof store) => {
    Request.interceptors.request.use((config) => {
        const token = rootStore.getState().auth.currentUser?.accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            config.headers.Authorization = '';
        }
        return config;
    });

    Request.interceptors.response.use(
        (response) => {
            return response;
        },
        (error: AxiosError<any>) => {
            // Do not redirect to /unauthorized if the check admin route returns a 403
            if (error.config?.url?.includes('admin/check')) {
                return Promise.reject(error);
            }

            // Do not redirect for user profile updates - let the component handle the error
            if (error.config?.url?.includes('/users/') && error.config?.method === 'put') {
                return Promise.reject(error);
            }

            // Do not redirect for invoice lookups — admin users get 403 on org-scoped
            // invoice endpoints; let the caller handle the error gracefully instead.
            if (error.config?.url?.includes('/invoices')) {
                return Promise.reject(error);
            }

            if (error.response?.status === 401) {
                rootStore.dispatch(logOut());
                return Promise.reject(error);
            }
            if (error.response?.status === 403) {
                window.location.href = '/unauthorized';
                return Promise.reject(error);
            }
            return Promise.reject(error);
        },
    );
};

export default Request;
